// Desktop nav links span the bar's content box so the active tab's underline
// lands on its bottom edge; below lg they stay stacked for the mobile menu.
export const navLinkClasses =
    "nav-link block py-2 px-0 lg:flex lg:items-center lg:py-0 lg:h-nav-inner";

// Items holding a button rather than a link: the button is shorter than the bar,
// so the item has to centre it instead of letting it hang from the top.
export const navButtonItemClasses = "nav-item flex items-center";
